import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiAward } from 'react-icons/fi';
import backofficeService from '../../../services/backofficeService';

const ChallengesList = () => {
  const [challenges, setChallenges] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadChallenges();
  }, []);

  const loadChallenges = async () => {
    try {
      const data = await backofficeService.getChallenges();
      setChallenges(data);
    } catch (error) {
      console.error('Erro ao carregar desafios:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem a certeza que deseja eliminar este desafio?')) return;
    
    try {
      await backofficeService.deleteChallenge(id);
      setChallenges(challenges.filter(c => c.id !== id));
    } catch (error) {
      alert('Erro ao eliminar desafio: ' + error.message);
    }
  };

  if (isLoading) {
    return (
      <div className="backoffice-page">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>A carregar desafios...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="backoffice-page challenges-list">
      <div className="page-header">
        <h1>Desafios</h1>
        <Link to="/backoffice/challenges/new" className="btn-primary">
          + Novo Desafio
        </Link>
      </div>

      {challenges.length > 0 ? (
        <table className="data-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Jogos</th>
              <th>Odd Total</th>
              <th>Montante</th>
              <th>Resultado</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {challenges.map((challenge) => (
              <tr key={challenge.id}>
                <td>{challenge.date}</td>
                <td>
                  <span className="games-count">{challenge.games?.length || 0} jogos</span>
                </td>
                <td>{challenge.total_odd || '-'}</td>
                <td>{challenge.amount || '-'}€</td>
                <td>
                  <span className={`status-badge ${challenge.result === 'won' ? 'success' : challenge.result === 'lost' ? 'danger' : 'info'}`}>
                    {challenge.result === 'won' ? 'Ganho' : challenge.result === 'lost' ? 'Perdido' : 'Pendente'}
                  </span>
                </td>
                <td>
                  <div className="table-actions">
                    <button 
                      onClick={() => navigate(`/backoffice/challenges/${challenge.id}`)}
                      className="action-btn edit"
                    >
                      Editar
                    </button>
                    <button 
                      onClick={() => handleDelete(challenge.id)}
                      className="action-btn delete"
                    >
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="empty-state">
          <FiAward className="empty-state-icon" />
          <h3>Sem desafios registados</h3>
          <p>Clique em "Novo Desafio" para adicionar o primeiro.</p>
        </div>
      )}
    </div>
  );
};

export default ChallengesList;
